export function isTelehealthPlanId(planId: string): boolean {
  return planId ? planId.includes("telehealth") : false;
}
